import { apiClient } from '../api/apiClient';

export interface DeletionStatus {
  isScheduledForDeletion: boolean;
  wasScheduledForDeletion: boolean;
  deleteDate: string | null;
}

export interface ScheduleDeletionResponse {
  message: string;
  delete_date: string;
}

class AccountService {
  /**
   * Schedule account deletion with 7-day grace period
   */
  async scheduleDeletion(): Promise<ScheduleDeletionResponse> {
    const response = await apiClient.post<ScheduleDeletionResponse>(
      '/api/v1/doctors/account/schedule-delete'
    );
    return response.data;
  }

  /**
   * Get current deletion status
   */
  async getDeletionStatus(): Promise<DeletionStatus> {
    const response = await apiClient.get<DeletionStatus>(
      '/api/v1/doctors/account/deletion-status'
    );
    return response.data;
  }
}

export const accountService = new AccountService();
